
 
var ControllerEvents = {

      needs_initializing: 'needs_initializing'
    
     ,session_state   : 'session_state' 
     ,authentication  : 'authentication'
     ,new_user_session: 'new_user_session'
     ,user_logout     : 'user_logout'
     ,call_request    : 'call_request'
     ,preparing_call  : 'preparing_call'
     ,grid_request    : 'grid_request'
     ,busy_request    : 'busy_request'

     ,request_can_save          : 'request_can_save'
     ,request_save              : 'request_save'
     ,save_info                 : 'save_info'
     ,confirm_save              : 'confirm_save'
     ,can_save                  : 'can_save'
     ,call_upload_recorded      : 'call_upload_recorded'
     ,final_state               : 'final_state'
     ,split_view_request        : 'split_view_request'
     ,gallery_filters_loaded    : 'gallery_filters_loaded'
     ,primary_filters_loaded : 'primary_filters_loaded'
     ,gallery_page_data_loaded  : 'gallery_page_data_loaded'
     ,gallery_details_loaded    : 'gallery_details_loaded'
     ,splashscreen_view_request : 'splashscreen_view_request'
     ,log_out                   : 'log_out'

}


module.exports = ControllerEvents;